import React from "react";
import clsx from "clsx";
import { useLocation, NavLink } from "react-router-dom";

import { SidebarTooltip, OnlineLink, HasPermissions } from "components";

import styles from "./sidebar.module.scss";

const MenuItem = ({
	label,
	text,
	to,
	rootPath = to,
	icon,
	requiredPermissions,
	isHidden,
}) => {
	const location = useLocation();

	if (isHidden) {
		return null;
	}

	const startsWithRootPath = location.pathname.startsWith(rootPath);
	const activeClass = startsWithRootPath && styles.active;

	const link = (
		<OnlineLink
			as={NavLink}
			to={to}
			className={clsx(activeClass, styles.menuBlock)}
		>
			{icon}
			{text}
		</OnlineLink>
	);

	return (
		<HasPermissions requiredPermissions={requiredPermissions}>
			{label ? (
				<SidebarTooltip text={label} placement="right">
					{link}
				</SidebarTooltip>
			) : (
				link
			)}
		</HasPermissions>
	);
};

export default MenuItem;
